import { render, staticRenderFns } from "./ProductWeight3.vue?vue&type=template&id=77017c1a&scoped=true&"
import script from "./ProductWeight3.vue?vue&type=script&lang=js&"
export * from "./ProductWeight3.vue?vue&type=script&lang=js&"
import style0 from "./ProductWeight3.vue?vue&type=style&index=0&id=77017c1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77017c1a",
  null
  
)

export default component.exports